export interface IAzurePlanUsage {
  azurePlanId: string; // Refers to Azure Plan Id, but is considered as any other Microsoft "Subscription" Id
  entitlementId: string;
  entitlementName: string;
  resourceGroupName: string;
  totalCost: number;
}

export default class AzurePlanUsage {
  private azurePlanId: string;
  private entitlementId: string;
  private entitlementName: string;
  private resourceGroupName: string;
  private totalCost: number;

  constructor(dto: IAzurePlanUsage) {
    Object.assign(this, dto);
  }

  get getAzurePlanId(): string {
    return this.azurePlanId;
  }

  set setAzurePlanId(azurePlanId: string) {
    this.azurePlanId = azurePlanId;
  }

  get getEntitlementId(): string {
    return this.entitlementId;
  }

  set setEntitlementId(entitlementId: string) {
    this.entitlementId = entitlementId;
  }

  get getEntitlementName(): string {
    return this.entitlementName;
  }

  set setEntitlementName(entitlementName: string) {
    this.entitlementName = entitlementName;
  }

  get getResourceGroupName(): string {
    return this.resourceGroupName;
  }

  set setResourceGroupName(resourceGroupName: string) {
    this.resourceGroupName = resourceGroupName;
  }

  get getTotalCost(): number {
    return this.totalCost;
  }

  set setTotalCost(totalCost: number) {
    this.totalCost = totalCost;
  }
}
